import { render, staticRenderFns } from "./contentCardBaseC.vue?vue&type=template&id=fbd6489a&scoped=true"
import script from "./contentCardBaseC.vue?vue&type=script&lang=js"
export * from "./contentCardBaseC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd6489a",
  null
  
)

export default component.exports